import getWebUsers from '../api/getWebUsers';
import { useEffect, useMemo, useState } from 'react';
import { useTable, usePagination, useSortBy, useFilters, useGlobalFilter } from 'react-table';

function classNames(...classes) {
    return classes.filter(Boolean).join(' ');
}

export default function useWebUsers() {
    const [users, setUsers] = useState([]);
    const [errorMessage, setErrorMessage] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [selectedUser, setSelectedUser] = useState(null);

    const queryUsers = async () => {
        const result = await getWebUsers(setErrorMessage);

        if (result) {
            setUsers(result);
            setIsLoading(false);
            return;
        }

        setIsLoading(false);

        setErrorMessage('No se pudo completar la solicitud de usuarios web. Inténtelo de nuevo.');
    };

    useEffect(() => {
        queryUsers();
    }, []);

    const _handleClick = (event, selectedItem) => {
        event.preventDefault();
        setSelectedUser(selectedItem);
    };

    const _closeUserView = () => {
        setSelectedUser(null);
    };

    const onSuccessUserUpdate = () => {
        _closeUserView();
        queryUsers();
    };

    const onNewUser = () => {
        setSelectedUser({});
    };

    const usersTable = useMemo(() => {
        return users.map((user) => {
            const fullName = `${user.firstName} ${user.lastName}`;
            return {
                col1: fullName,
                col2: user.email,
                col3: new Date(user.creation).toLocaleDateString(),
                col4: (
                    <span
                        className={classNames(
                            'inline-flex rounded-full px-2 text-xs font-semibold leading-5',
                            user.status ? 'bg-green-100' : '',
                            !user.status ? 'bg-red-100' : '',
                            user.status ? 'text-green-800' : '',
                            !user.status ? 'text-red-800' : ''
                        )}
                    >
                        {user.status ? 'Activo' : 'Inactivo'}
                    </span>
                ),
                col5: (
                    <div
                        onClick={(e) => _handleClick(e, user)}
                        className="text-dl-primary-900 hover:text-dl-accent cursor-pointer"
                    >
                        Editar
                        <span className="sr-only">, {fullName}</span>
                    </div>
                )
            };
        });
    }, [users]);

    const userColumns = useMemo(() => {
        return [
            {
                Header: 'Nombre',
                accessor: 'col1' // accessor is the "key" in the data
            },
            {
                Header: 'Correo electrónico',
                accessor: 'col2' // accessor is the "key" in the data
            },
            {
                Header: 'Fecha de creación',
                accessor: 'col3' // accessor is the "key" in the data
            },
            {
                Header: 'Estado',
                accessor: 'col4' // accessor is the "key" in the data
            },
            {
                Header: 'Acciones',
                accessor: 'col5' // accessor is the "key" in the data
            }
        ];
    }, []);

    const userTableInstance = useTable(
        { columns: userColumns, data: usersTable },
        useFilters, // useFilters!
        useGlobalFilter, // useGlobalFilter!,
        useSortBy,
        usePagination
    );

    return {
        users,
        errorMessage,
        queryUsers,
        usersTable,
        isLoading,
        setIsLoading,
        userColumns,
        userTableInstance,
        _closeUserView,
        selectedUser,
        onSuccessUserUpdate,
        onNewUser
    };
}
